export const MAX_CHIP_COUNT = 500;
export const ORDER_SLOT_ROW_HEIGHT = 88;
export const DROP_SLOT_ROW_HEIGHT = 72;
export const DROP_SLOT_OVERSCAN = 10;
